import {
  ButtonsDropdownOption,
  Dropdown,
  dropdownTypes,
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { removeErrorMessage } from "slices/app/errorSlice";
import { setPasswordExpiry } from "slices/systemAdmin/actions/systemAdmin";
import { setPasswordExpiryPeriod as setStorePasswordExpiryPeriod } from "slices/systemAdmin/systemAdminSlice";

const options = [
  { content: <span>30</span>, filter: 30 },
  { content: <span>60</span>, filter: 60 },
  { content: <span>90</span>, filter: 90 },
  { content: <span>120</span>, filter: 120 },
  { content: <span>300</span>, filter: 300 },
  { content: <span>Never</span>, filter: -1 },
];

export const getOptionButton = ({ option, setPasswordExpiryPeriod }) => {
  return (
    <ButtonsDropdownOption
      text={option.content}
      content={option.content}
      onClick={() => {
        setPasswordExpiryPeriod(option.filter);
      }}
    />
  );
};

const PasswordExpiryModal = ({ expiryDays, workspaceId }) => {
  const dispatch = useDispatch();
  const [passwordExpiryPeriod, setPasswordExpiryPeriod] = useState(
    expiryDays || -1
  );

  const handleClose = () => {
    dispatch(hideModal(modalTypes.PASSWORD_EXPIRY));
  };

  const handleSuccess = () => {
    dispatch(
      setStorePasswordExpiryPeriod({ workspaceId, passwordExpiryPeriod })
    );
    handleClose();
  };

  const onSubmit = () => {
    dispatch(removeErrorMessage());
    dispatch(
      setPasswordExpiry(workspaceId, passwordExpiryPeriod, handleSuccess)
    );
  };

  return (
    <Modal
      data-testid="password-expiry-modal"
      className="fade-in password_expiry_modal"
      show
      onDismiss={handleClose}
      backdrop
      centered
    >
      <Modal.Header>
        <b>Password Expiry</b>
      </Modal.Header>
      <Modal.Body>
        <div className="form__field__number_of_days">
          <b>Number of Days</b>
          <Dropdown
            type={dropdownTypes.buttons}
            propsObject={{
              text:
                passwordExpiryPeriod === -1
                  ? "Never"
                  : String(passwordExpiryPeriod),
              options: options.map((o) =>
                getOptionButton({ option: o, setPasswordExpiryPeriod })
              ),
              buttonVariant: "l2",
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <NewButton
          data-testid="cancel-button"
          variant={NewButtonVariant.l2}
          onClick={handleClose}
        >
          Cancel
        </NewButton>

        <NewButton
          variant={NewButtonVariant.l1}
          onClick={onSubmit}
          data-testid="ok-button"
        >
          Ok
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default PasswordExpiryModal;

PasswordExpiryModal.propTypes = {
  expiryDays: PropTypes.string.isRequired,
  workspaceId: PropTypes.number.isRequired,
};
